export const initialState = {
  requiredDocument: {
    requiredDocTypeId: null,
    documentName: '',
    documentCode: '',
    sharePointContentType: '',
    changed: false
  }
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnHeaderPropertyChanged':
      return onHeaderPropertyChanged(state, action);
    case 'OnHeaderSaved':
      return onHeaderSaved(state, action);
    default:
      return state;
  }
}

function onHeaderSaved(state, action) {
  const { requiredDocumentId } = action;
  return {
    ...state,
    requiredDocument: {
      ...state.requiredDocument,
      requiredDocTypeId: requiredDocumentId,
      changed: false
    }
  };
}

function onInitState(state, action) {
  const { requiredDocument } = action.data;
  return {
    ...state,
    requiredDocument: { ...requiredDocument, changed: false }
  };
}

function onHeaderPropertyChanged(state, action) {
  const { propertyName, value } = action;
  return {
    ...state,
    requiredDocument: {
      ...state.requiredDocument,
      [propertyName]: value,
      changed: true
    }
  };
}
